export type OrderTableKey = 'product' | 'date' | 'status';

export type OrderTableItem = Record<OrderTableKey, string>;

export type OrderTableWidthCols = Record<OrderTableKey, number>;

export const tableHead: OrderTableItem = {
  product: 'Produto',
  date: 'Data/hora',
  status: 'Status',
};

export const desktopWidthCols: OrderTableWidthCols = {
  product: 65,
  date: 20,
  status: 15,
};

export const desktopMaxHeight = 550;
